import { Utils } from '@gv/triage-components';
import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { apiQuery } from 'store/query';
import { generateUrl } from 'utils/helpers';

export interface PhoneNumber {
  id: number;
  label?: string;
  purpose?: string;
  dateAdded: string;
  spendType?: string;
  phoneNumber: string;
  campaignName?: string;
  spendPerMonth?: number;
  status: 'active' | 'inactive';
}

export interface PhoneNumbersListResponse {
  data: { data: PhoneNumber[] };
}

export interface PhoneNumbersListRequest {
  search?: string;
  hospitalId: string;
}

export interface UpdatePhoneNumberStatusRequest {
  hospitalId: string;
  phoneNumberId: number;
  status: 'active' | 'inactive';
}

const tagType = 'PhoneNumbers';

export const phoneNumbersApi = createApi({
  tagTypes: [tagType],
  baseQuery: apiQuery,
  reducerPath: 'phoneNumbersApi',
  endpoints: (build) => ({
    updateStatus: build.mutation<PhoneNumber, UpdatePhoneNumberStatusRequest>({
      invalidatesTags: [tagType],
      query: ({ status, hospitalId, phoneNumberId }) => ({
        method: 'patch',
        data: { status },
        url: generateUrl(URL.PHONE_NUMBER_UPDATE_STATUS, {
          status,
          hospitalId,
          phoneNumberId,
        }),
      }),
    }),
    list: build.query<PhoneNumber[], PhoneNumbersListRequest>({
      providesTags: [tagType],
      transformResponse: (response: PhoneNumbersListResponse) =>
        response?.data?.data || [],
      query: ({ search, hospitalId }) => {
        let url = generateUrl(URL.PHONE_NUMBERS_LIST, { hospitalId });
        if (search) {
          url = Utils.Query.addParamsToUrl(url, { search });
        }
        return {
          url,
          method: 'get',
        };
      },
    }),
  }),
});

export const { useListQuery, useUpdateStatusMutation } = phoneNumbersApi;
